export const wallboxErrorCodes = {
  wallboxPriceNotSet: 12003,
  hasNoWallboxes: 12004,
}
